<template>
  <div>
    <gerenciamento-produtos />
  </div>
</template>

<script>
// TODO: Excluir esse componente ao finalizar a integração
export default {
  name: 'GerenciamentoModulos',
  components: {
    GerenciamentoProdutos: () => import('./GerenciamentoProdutos.vue'),
  },
  props: {
    myProp: {
      type: String,
      default: '',
    },
  },
  data: () => ({}),
  computed: {},
  watch: {},
  mounted() {},
  methods: {},
}
</script>

<style lang="scss"></style>
